import { Text } from '../..';

const TitleEvaluationIndustrial = ({ title, backgroundColor = "#F4F4F4", colorTitle = "#555" }) => {
    return (
        <div style={{ width: "100%", borderRadius: "8px", backgroundColor, textAlign: "center", marginBottom: 10, padding: "5px 0"}}>
            <Text style={{ fontSize: 14, fontWeight: "bold", color: colorTitle }}>{title}</Text>
        </div>
    );
}

export default TitleEvaluationIndustrial;